import * as ActionTypes from './actionTypes'

// Set isLoading for data
export function setIsLoading(isLoading) {
  return dispatch => {
    dispatch({ type: ActionTypes.SET_IS_LOADING, payload: isLoading })
  }
}